import { CHBookingList } from '../mdl/c-booking-home';
import { CEventTagId } from '../mdl/c-event-tag';
import { CPlan } from '../mdl/c-plan';
import { CAccountStatus, CLoginUser, CPaidPlanId, CRecurringStatus, CSubscription } from '../mdl/c-user';
import { EMaybePaymentIntent, EPaymentIntent } from '../mdl/e-payment-intent';
import { EPaymentMethod } from '../mdl/e-payment-method';
import { EHUserTransaction } from '../mdl/e-user-transaction';
import { FRoute } from '../mdl/f-route';
import { PCodeContext, PCodeKind, PPromo } from '../mdl/p-promo';
import { TLActionChangePlanInfo, TLActionSubscribeInfo, TLActionUnsubscribeInfo, TLReferralUser } from '../mdl/zzz-legacy-user';
import { YPaymentAmount } from '../y/amount';
import { $api } from '../y/api';
import { $date, YDate } from '../y/time';
import { YDateString, YId } from '../y/types';
import { the_user } from './login';

export interface CMembershipView {
    recurring_status: CRecurringStatus;
    payment_date?: YDateString;
    payment_amount?: YPaymentAmount;
    payment_method?: EPaymentMethod;
    plan?: CPlan;
    subscription?: CSubscription;
    transactions: EHUserTransaction[];
}

export function meUpdateEventTags(event_tag_ids: CEventTagId[]) {
    const me = the_user!;
    return $api.PUT('me/event_tags', { event_tag_ids }).then(() => {
        me.event_tag_ids = event_tag_ids;
    })
}

export function hasEventTags(tags: YId[]) {
    for(const t of the_user!.event_tag_ids) {
        if(tags.includes(t)) return true;
    }

    return false;
}

function getActiveSubscriptionOn(subscriptions: CSubscription[], when: YDate) {
    return subscriptions.find(s => !$date(s.start_date).after(when) && $date(s.end_date).after(when));
}

export function hasSubscriptions() {
    return !!the_user?.subscriptions.length;
}

export function meGetStatus(): CAccountStatus {
    const user = the_user;
    if(!user)
        return 'none';

    const subscription = getActiveSubscriptionOn(user.subscriptions, $date.today())

    switch(user.recurring_status) {
        case 'active':
            return 'active';
        case 'inactive':
            if(subscription) {
                if(subscription.type == 'gc') {
                    return 'giftcard'
                } else if(subscription.type == 'free') {
                    return 'free';
                } else {
                    return 'pending_cancel';
                }
            } else if(user.subscriptions.length) {
                return 'cancelled';
            } else {
                return 'none';
            }
        case 'pastdue':
            return 'pastdue';
        case 'paused':
            if(subscription) {
                return 'pending_pause';
            } else {
                return 'paused';
            }
    }
}

export function hasActiveStatus() {
    const user = the_user;
    if(!user)
        return false;

    const subscription = getActiveSubscriptionOn(user.subscriptions, $date.today())

    return user.recurring_status == 'active' || user.recurring_status == 'pastdue' || !!subscription;
}

export function meGetInfo(action: 'unsubscribe'): Promise<TLActionUnsubscribeInfo>
export function meGetInfo(action: 'subscribe'): Promise<TLActionSubscribeInfo>
export function meGetInfo(action: 'change_plan'): Promise<TLActionChangePlanInfo>
export function meGetInfo(action: 'membership'): Promise<CMembershipView>
export function meGetInfo(action: string) {
    return $api.GET<any>(`me/${action}`);
}

export function meAction(action: 'subscribe', params: { plan: CPaidPlanId }): Promise<EPaymentIntent | true>
export function meAction(action: 'unsubscribe', params: { notes?: string }): Promise<true>;
export function meAction(action: 'change_plan', params: { plan: CPaidPlanId }): Promise<EPaymentIntent | true>
export function meAction(action: 'pause', params: { months: number }): Promise<true>;
export function meAction(action: 'unpause'): Promise<EPaymentIntent | true>
export function meAction(action: 'redeem_gc', params: { code: string }): Promise<true>;
export function meAction(action: 'change_payment'): Promise<EPaymentIntent>
export function meAction(action: string, params?: any) {
    return $api.POST<EMaybePaymentIntent<CLoginUser>>(`me/${action}`, params).then(response => {
        if(response.intent)
            return response.intent;
        Object.assign(the_user!, response.data);
        return true;
    });
}

export interface MeUseCodeResponse {
    kind: PCodeKind;
    user: CLoginUser;
    promo?: PPromo;
}

export function meUseCode(context: PCodeContext, code: string) {
    return $api.POST<MeUseCodeResponse>('me/use_code', { context, code }).then(r => {
        Object.assign(the_user!, r.user);
        return r;
    });
}

declare global {
    interface Window {
        ab_referral_user?: TLReferralUser;
        ab_reserved_booking?: CHBookingList;
        ab_codes?: string[];
        ab_signup_promo: PPromo;
        ab_routes: FRoute[];
    }
}
